import transactionLinkServices from 'services/application/transaction/transactionLink';

export default {
	...transactionLinkServices,
};
